export const SET_PROJECT_ROLE = 'SET_PROJECT_ROLE';